import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
export function BonusSection() {
  const fadeInUp = {
    initial: {
      opacity: 0,
      y: 20
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true
    },
    transition: {
      duration: 0.5
    }
  };
  const bonuses = [{
    title: 'Planificador de Recetas',
    description: 'Organizá tus comidas de forma simple y dejá de improvisar cada día.',
    value: 9000,
    image: 'https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?w=400&h=300&fit=crop'
  }, {
    title: 'Recetario Especial de Galletas',
    description: 'Una selección de recetas irresistibles para darte gustos sin salirte de tu objetivo.',
    value: 12000,
    image: 'https://images.unsplash.com/photo-1558961363-fa8fdf82db35?w=400&h=300&fit=crop'
  }, {
    title: 'Extra Digital Exclusivo',
    description: 'Un complemento ideal para sumar más variedad y mantenerte motivada.',
    value: 10000,
    image: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=400&h=300&fit=crop'
  }];
  return <section className="py-16 px-4 bg-gradient-to-br from-yellow-50 via-amber-50 to-orange-50" data-id="element-12">
      <div className="max-w-4xl mx-auto" data-id="element-13">
        <motion.div {...fadeInUp} className="text-center mb-12" data-id="element-14">
          <h2 className="font-playfair text-3xl md:text-5xl font-bold text-dark mb-4" data-id="element-15">
            Además, hoy te llevás estos BONOS DE REGALO
          </h2>
        </motion.div>

        <div className="space-y-6 mb-12" data-id="element-16">
          {bonuses.map((bonus, index) => <motion.div key={index} {...fadeInUp} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-xl shadow-lg p-6 border-2 border-gold/20" data-id="element-17">
              <div className="flex flex-col md:flex-row gap-6" data-id="element-18">
                <img src={bonus.image} alt={bonus.title} className="w-full md:w-32 h-32 object-cover rounded-lg flex-shrink-0" data-id="element-19" />

                <div className="flex-1" data-id="element-20">
                  <div className="flex items-start gap-3 mb-3" data-id="element-21">
                    <Gift className="w-6 h-6 text-gold flex-shrink-0 mt-1" data-id="element-22" />
                    <div data-id="element-23">
                      <h3 className="font-playfair text-xl md:text-2xl font-bold text-dark mb-2" data-id="element-24">
                        Bono #{index + 1}: {bonus.title}
                      </h3>
                      <p className="text-dark/70 mb-3" data-id="element-25">{bonus.description}</p>
                      <div className="flex items-center gap-3" data-id="element-26">
                        <span className="text-dark/50 line-through" data-id="element-27">
                          Valor: <PriceDisplay amount={bonus.value} data-id="element-28" />
                        </span>
                        <span className="bg-primary text-white px-4 py-1 rounded-full font-bold text-sm" data-id="element-29">
                          HOY GRATIS
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div {...fadeInUp} className="bg-gradient-to-br from-gold/20 to-amber-200/30 border-2 border-gold rounded-xl p-8" data-id="element-30">
          <h3 className="font-playfair text-2xl font-bold text-dark mb-6 text-center" data-id="element-31">
            Valor total del paquete:
          </h3>

          <div className="space-y-3 mb-6" data-id="element-32">
            <div className="flex justify-between items-center" data-id="element-33">
              <span className="text-dark/80" data-id="element-34">Recetario principal:</span>
              <PriceDisplay amount={15000} className="font-semibold" data-id="element-35" />
            </div>
            <div className="flex justify-between items-center" data-id="element-36">
              <span className="text-dark/80" data-id="element-37">Bono 1:</span>
              <PriceDisplay amount={3000} className="font-semibold" data-id="element-38" />
            </div>
            <div className="flex justify-between items-center" data-id="element-39">
              <span className="text-dark/80" data-id="element-40">Bono 2:</span>
              <PriceDisplay amount={5000} className="font-semibold" data-id="element-41" />
            </div>
            <div className="flex justify-between items-center" data-id="element-42">
              <span className="text-dark/80" data-id="element-43">Bono 3:</span>
              <PriceDisplay amount={10000} className="font-semibold" data-id="element-44" />
            </div>

            <div className="border-t-2 border-gold/30 pt-4 mt-4" data-id="element-45">
              <div className="flex justify-between items-center" data-id="element-46">
                <span className="font-playfair text-xl font-bold text-dark" data-id="element-47">
                  VALOR TOTAL:
                </span>
                <PriceDisplay amount={33000} className="text-2xl line-through text-dark/50" data-id="element-48" />
              </div>
            </div>
          </div>

          <p className="text-center text-xl font-bold text-dark" data-id="element-49">
            Pero hoy no vas a pagar eso.
          </p>
        </motion.div>
      </div>
    </section>;
}